export const formatPounds = function (
  amount: number,
  denomination: "pennies" | "pounds" = "pennies",
  omitDecimals = false,
  options?: Intl.NumberFormatOptions,
) {
  let _amount = amount;
  if (denomination === "pennies") {
    _amount = amount / 100;
  }

  return _amount.toLocaleString("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: omitDecimals ? 0 : 2,
    minimumFractionDigits: omitDecimals ? 0 : 2,
    ...options,
  });
};
